/**
 * Created by jpilz on 2/13/17.
 */
import ko from 'knockout';
import axios from 'axios';

export default class preferencesUtil {

    constructor(context) {
        this.name = "preferencesUtil";
        this.context = context;
        this.debug = false;

        this.log("preferencesUtil");
    }

    log(obj)
    {
        if(this.debug)
        {
            console.log("--------------");
            console.log(this.name + ":");
            console.log(obj);
        }
    }

    getPreferences() {

        // Where {"where": {"appId":"appID","subId":"sunID","userId":"userID"}}

        //getPreferences
        console.log("preferencesUtil:getPreferences");

        let filter = encodeURI(JSON.stringify({ "where" : { "subid": this.context.subparentid(), "partnerid": this.context.partnerid()}}));
        let url = this.context.generateApiUrl('/Preferences?filter=' + filter);
        let callData = JSON.stringify({});

        
        return new Promise((resolve, reject) => {
            axios({
                url: url,
                method: 'get',
                headers: this.context.apiContentType,
                data: callData
            }).then((response) => {
                console.log("preferencesUtil:getPreferences: response; %o", response);
                if(response.data.length === 0)
                {
                    console.log("preferencesUtil:Blank Preferences")
                    this.context.preferencesId(null);
                }
                else
                {
                    console.log("preferencesUtil:Received Preferences")
                    this.context.preferences(JSON.parse(response.data[0].data));
                    this.context.preferencesId(response.data[0].id);
                    this.context.preferences.valueHasMutated();
                }
                console.log("preferencesUtil:getPreferences: context.preferences; %o", this.context.preferences());
                resolve(response.data);
            }).catch((error) =>{
                this.log("getPreferencestyles Error:");
                reject(error);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error loading preferences"},"messageModel");
                return;
            });
        });
    }

    updatePreferences() {
        console.log("preferencesUtil:updatePreferences context.preferences: %o", this.context.preferences());

        let url = this.context.generateApiUrl('/Preferences/replaceOrCreate');
        let callData = JSON.stringify({id:this.context.preferencesId(), data: ko.toJSON(this.context.preferences), subid: this.context.subparentid(), partnerid: this.context.partnerid()});

        return new Promise((resolve, reject) => {
            axios({
                url: url,
                method: 'POST',
                headers: this.context.apiContentType,
                data: callData
            }).then((response) => {
                console.log("preferencesUtil:updatePreferences: response: %o", response);
                this.context.preferencesId(response.data.id);
                this.context.preferences.valueHasMutated();
                resolve(response);
            }).catch((error) =>{
                console.log("preferencesUtil:updatePreferences: error: %o", error);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error processing updatePreferences"},"messageModel");
                reject(error);
                return;
            });
        });
    }


    

}




// WEBPACK FOOTER //
// ./src/objects/preferencesUtil.js